import Vue from 'vue'
import { getProperty } from '@appbase/util'
import { loadSript } from './script-loader'

export const initializeAsync = () => {
  return new Promise<void>((resolve) =>
    loadSript('/cm/gres/js/boardFieldSetting.js', 'eum-board-setting', resolve)
  )
}

export const ids = () => {
    return getProperty(window, 'eumBoardIds') as common.BoardFieldSetting;
}

export { default as routes } from './router'
export { default as store } from './store'
